export default "__VITE_ASSET__C7a9w4W$__"